import Transform from '@ember-data/serializer/transform';

import { convertApiTagToTag } from 'shared/utils/post-tagging/post-tagging';

import type { ApiTag, Tag } from 'shared/types/post-tagging';

export default class TagArrayTransform extends Transform {
  deserialize(value?: ApiTag[]): Tag[] {
    return Array.isArray(value) ? value.map(convertApiTagToTag) : [];
  }

  serialize(value?: Tag[]): string[] {
    // API expects an array of tag IDs when saving tags
    return Array.isArray(value) ? value.map((tag) => tag.id) : [];
  }
}

declare module 'ember-data/types/registries/transform' {
  export default interface ModelRegistry {
    'tag-array': Tag[];
  }
}
